import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const documentApiRoutes = {
    listBusSched: apiDataManagerBaseURL + "documents/listbussched",
    listBusMap: apiDataManagerBaseURL + "documents/listbusmap",
};

export class DocumentAPI {
    static listBusScheds(provider = '') {
        return API.authenticatedRequest({
            url: provider === '' ? documentApiRoutes.listBusSched : `${documentApiRoutes.listBusSched}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listBusMaps(provider = '') {
        return API.authenticatedRequest({
            url: provider === '' ? documentApiRoutes.listBusMap : `${documentApiRoutes.listBusMap}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
